const runId = "00000000-0000-4000-8000-000000000301";
const observedAt = "2026-06-05T21:45:00.000Z";

export const dappStoreMockDiscoverySnapshot = deepFreeze({
  run: {
    id: runId,
    sequence: 9,
    startedAt: "2026-06-05T21:41:00.000Z",
    asOf: observedAt,
    completedAt: "2026-06-05T22:08:00.000Z",
    status: "complete",
    scraperVersion: "0.1.0",
    parserVersion: "0.1.0",
    sourceRevision: "mock-public-projection",
    categories: ["Analytics", "Commerce", "Creators", "DeFi", "Governance", "Lifestyle", "NFTs", "Rewards", "Tools", "Wallets"],
    appCount: 10,
    categoryCount: 10,
    runPayloadHash: "sha256:4d8f2c1a2"
  },
  categories: [
    category("tools", "Tools", ["swap-studio", "wallet-atlas", "governance-desk", "commerce-checkout"]),
    category("lifestyle", "Lifestyle", ["moonwalk-fitness", "rewards-track", "creator-audio"]),
    category("defi", "DeFi", ["swap-studio", "liquidity-map"]),
    category("wallets", "Wallets", ["wallet-atlas", "vault-teams"]),
    category("governance", "Governance", ["governance-desk", "vault-teams"]),
    category("rewards", "Rewards", ["moonwalk-fitness", "rewards-track"]),
    category("creators", "Creators", ["gallery-market", "creator-audio"]),
    category("analytics", "Analytics", ["liquidity-map"]),
    category("commerce", "Commerce", ["commerce-checkout"]),
    category("nfts", "NFTs", ["gallery-market"])
  ],
  apps: [
    app("swap-studio", "Swap Studio", {
      developer: "Studio Markets",
      shortSummary: "Compare token routes and quotes.",
      categories: ["DeFi", "Tools"],
      starRating: 4.3,
      totalReviews: 214,
      updatedOnDate: "2026-06-01",
      currentVersion: "3.8.1",
      publicLinks: {
        developerWebsite: "https://swap.example",
        privacyPolicy: "https://swap.example/privacy"
      },
      permissions: [
        group("Network", ["view network connections", "have full network access"]),
        group("Storage", ["read shared storage"])
      ]
    }),
    app("moonwalk-fitness", "Moonwalk Fitness", {
      developer: "Moonwalk Fitness",
      shortSummary: "Track steps and compete daily.",
      categories: ["Lifestyle", "Rewards"],
      starRating: 4.8,
      totalReviews: 123,
      updatedOnDate: "2026-05-28",
      currentVersion: "1.4.2",
      publicLinks: {
        developerWebsite: "https://moonwalk.example"
      },
      permissions: [
        group("Network", ["view network connections", "have full network access"]),
        group("Activity", ["run foreground service"])
      ]
    }),
    app("rewards-track", "Rewards Track", {
      developer: "Daily Labs",
      shortSummary: "Track tasks, points, and redemptions.",
      categories: ["Rewards", "Lifestyle"],
      starRating: 4.6,
      totalReviews: 95,
      updatedOnDate: "2026-05-11",
      currentVersion: "1.7.1",
      publicLinks: {
        terms: "https://rewards.example/terms"
      },
      permissions: [
        group("Network", ["view network connections", "have full network access"]),
        group("Location", ["approximate location"]),
        group("Notifications", ["post notifications"])
      ]
    }),
    app("wallet-atlas", "Wallet Atlas", {
      developer: "Atlas Labs",
      shortSummary: "Organize wallet activity and labels.",
      categories: ["Wallets", "Tools"],
      starRating: 4.5,
      totalReviews: 78,
      updatedOnDate: "2026-04-16",
      currentVersion: "2.1.0",
      permissions: [
        group("Network", ["have full network access"]),
        group("Security", ["use biometric hardware"])
      ]
    }),
    app("gallery-market", "Gallery Market", {
      developer: "Gallery Systems",
      shortSummary: "Browse collectibles and creator drops.",
      categories: ["NFTs", "Creators"],
      starRating: 4.1,
      totalReviews: 66,
      updatedOnDate: "2025-11-14",
      currentVersion: "1.9.5",
      permissions: [
        group("Network", ["have full network access"]),
        group("Media", ["read photos and videos"])
      ]
    }),
    app("liquidity-map", "Liquidity Map", {
      developer: "Route Foundry",
      shortSummary: "Monitor pool depth and route changes.",
      categories: ["DeFi", "Analytics"],
      starRating: 3.9,
      totalReviews: 42,
      updatedOnDate: "2025-07-21",
      currentVersion: "2.3.4",
      permissions: [
        group("Network", ["view network connections", "have full network access"]),
        group("Storage", ["read shared storage"])
      ]
    }),
    app("governance-desk", "Governance Desk", {
      developer: "Civic Stack",
      shortSummary: "Follow proposals and voting windows.",
      categories: ["Governance", "Tools"],
      starRating: 4.7,
      totalReviews: 31,
      updatedOnDate: "2026-03-04",
      currentVersion: "0.9.7",
      permissions: [
        group("Network", ["view network connections", "have full network access"]),
        group("Notifications", ["post notifications"])
      ]
    }),
    app("creator-audio", "Creator Audio", {
      developer: "Signal Studio",
      shortSummary: "Publish and collect audio drops.",
      categories: ["Creators", "Lifestyle"],
      starRating: 4.0,
      totalReviews: 18,
      updatedOnDate: null,
      currentVersion: "",
      permissions: [
        group("Network", ["have full network access"]),
        group("Media", ["record audio", "read photos and videos"])
      ]
    }),
    app("commerce-checkout", "Commerce Checkout", {
      developer: "Point Labs",
      shortSummary: "Accept checkout links and receipts.",
      categories: ["Commerce", "Tools"],
      starRating: 3.7,
      totalReviews: 9,
      updatedOnDate: "2024-12-09",
      currentVersion: "0.8.4",
      permissions: [
        group("Network", ["have full network access"]),
        group("Camera", ["take pictures and videos"])
      ]
    }),
    app("vault-teams", "Vault Teams", {
      developer: "Vault Cooperative",
      shortSummary: "Coordinate shared treasury actions.",
      categories: ["Wallets", "Governance"],
      starRating: null,
      totalReviews: null,
      updatedOnDate: "2026-01-18",
      currentVersion: "1.0.0",
      permissions: [
        group("Network", ["have full network access"]),
        group("Security", ["use biometric hardware"]),
        group("Notifications", ["post notifications"])
      ]
    })
  ]
});

function app(appKey, appName, options) {
  const totalReviews = Number.isFinite(options.totalReviews) ? options.totalReviews : null;
  const starRating = typeof options.starRating === "number" ? options.starRating : null;
  const publicLinks = { ...(options.publicLinks || {}) };
  const iconUrl = options.iconUrl || publicLinks.iconUrl || mockIconDataUrl(appKey, appName);
  if (iconUrl && !publicLinks.iconUrl) publicLinks.iconUrl = iconUrl;
  return {
    appKey,
    runId,
    appName,
    appDescription: `${appName} helps Solana Mobile users discover activity, track changes, and coordinate decisions from a mobile-first app experience.`,
    shortSummary: options.shortSummary,
    iconUrl,
    currentVersion: options.currentVersion,
    starRating,
    starBreakdown: starRating == null ? null : buildStarBreakdown(totalReviews || 1),
    totalReviews,
    updatedOnText: options.updatedOnDate || "",
    updatedOnDate: options.updatedOnDate,
    requiredOs: "Android 12 and up",
    developer: options.developer,
    sizeText: "Not captured",
    languageSummary: "English",
    languages: ["English"],
    permissions: options.permissions,
    publicLinks,
    reviews: starRating == null ? { histogram: null, aggregateStatus: "not-captured" } : { histogram: null, aggregateStatus: "captured" },
    categories: options.categories,
    scrapeStatus: "complete",
    errors: [],
    asOf: observedAt,
    listingObservedAt: observedAt,
    detailObservedAt: observedAt,
    contentHash: `sha256:content-${appKey}`,
    metricsHash: `sha256:metrics-${appKey}`,
    payloadHash: `sha256:payload-${appKey}`
  };
}

function mockIconDataUrl(appKey, appName) {
  const initials = String(appName || "?").split(/\s+/).map((word) => word[0]).join("").slice(0, 2).toUpperCase();
  const hue = hashString(appKey) % 360;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><rect width="80" height="80" rx="18" fill="hsl(${hue} 62% 34%)"/><text x="40" y="47" text-anchor="middle" font-family="Arial, sans-serif" font-size="26" font-weight="700" fill="white">${escapeSvgText(initials)}</text></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

function hashString(value) {
  let hash = 0;
  for (const character of String(value || "")) {
    hash = ((hash << 5) - hash + character.charCodeAt(0)) | 0;
  }
  return Math.abs(hash);
}

function escapeSvgText(value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function buildStarBreakdown(totalReviews) {
  return {
    "5": Math.max(1, Math.round(totalReviews * 0.48)),
    "4": Math.max(0, Math.round(totalReviews * 0.28)),
    "3": Math.max(0, Math.round(totalReviews * 0.14)),
    "2": Math.max(0, Math.round(totalReviews * 0.06)),
    "1": Math.max(0, Math.round(totalReviews * 0.04))
  };
}

function category(categoryKey, categoryName, appKeys) {
  return {
    categoryKey,
    categoryName,
    runId,
    asOf: observedAt,
    scrapeStatus: "complete",
    appKeys,
    listingSummaries: [],
    payloadHash: `sha256:category-${categoryKey}`
  };
}

function group(groupName, items) {
  return { group: groupName, items };
}

function deepFreeze(value) {
  if (!value || typeof value !== "object" || Object.isFrozen(value)) return value;
  Object.freeze(value);
  for (const child of Object.values(value)) {
    deepFreeze(child);
  }
  return value;
}
